module.exports = __webpack_public_path__ + "static/media/league-gothic.91295fa8.ttf";